import { useCallback } from "react";
import { soundManager } from "./audioManager";

const useVictoryAudio = () => {
    return useCallback(() => {
        try {
            soundManager.play("VictoryAudio", { volume: 0.3 + Math.random() * 0.2 });
        } catch (error) {
            console.error("Error playing victory sound:", error);
        }
    }, []);
};

export default useVictoryAudio;
